import * as moment from "moment";

export const formatIndianRupees = (amount: number): string => {
  if (amount < 0) {
    amount = 0;
  }
  amount /= 100;
  if (amount === undefined || isNaN(amount)) {
    // Handle the case where amount is undefined or not a number
    return "₹ 0.00"; // Or any default value you prefer
  }
  let strAmount = amount.toString();

  let [integerPart, decimalPart] = strAmount.split(".");

  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  if (decimalPart) {
    decimalPart = decimalPart.slice(0, 3);
  } else {
    decimalPart = "00";
  }
  return `₹ ${integerPart}.${decimalPart}`;
};

export const formatNormalIndianRupees = (amount: any) => {
  if (amount < 0) {
    amount = 0;
  }
  if (amount === undefined || isNaN(amount)) {
    // Handle the case where amount is undefined or not a number
    return "₹ 0.00"; // Or any default value you prefer
  }
  let strAmount = String(amount);
  let [integerPart = "0", decimalPart = "00"] = strAmount.split(".");
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  if (decimalPart) {
    decimalPart = decimalPart.slice(0, 3);
  } else {
    decimalPart = "00";
  }
  return `₹ ${integerPart}.${decimalPart}`;
};

export const dateParser = (date: string = "", format: string = "") => {
  if (date?.length) return moment.parseZone(date).format(format);
  else return moment.parseZone().format(format);
};

export const handlePercentAmount = (
  loanAmount: number,
  repayAmount: number,
  type: string
) => {
  if (type === "disburse") {
    return ((loanAmount / repayAmount) * 100).toFixed(2);
  }
  if (type === "sanction") {
    let remainingAmount = repayAmount - loanAmount;
    return ((remainingAmount / repayAmount) * 100).toFixed(2);
  }
};
export const handlePercentAmountFlexi = (
  totallimit: number,
  utilization: number,
  available: number,
  type: string
) => {
  if (totallimit==0) {
    return 0;
  }
  if (type === "disburse") {
    return ((utilization / totallimit) * 100).toFixed(2);
  }
  if (type === "sanction") {
    return ((available/totallimit) * 100).toFixed(2);
  }
};
export const checkPercentage = (item: any) => {
  return ((item?.loanAmount / item?.repayAmount) * 100).toFixed(2);
};

export const flexiCheckPercentage = (item: any) => {
  let val = Number(((item?.totalLimit - item?.availableLimit) / item?.totalLimit) * 100);
  if (isNaN(val)){
     return 0;
  }
  return val;
};
export const formatDateAndTime = (value:string) => {
  return new Date(value)?.toISOString().split("T")[0] ;
}
export const toPascalCase = (str: string) => {
  if (!str) return "";
  return str
    .replace(/[_\s-]+/g, ' ') // replace underscores, hyphens with space
    .toLowerCase()
    .replace(/(?:^|\s)(\w)/g, (_, c) => c.toUpperCase()) // capitalize first letter of each word
    .replace(/\s+/g, ''); // remove remaining spaces
};

